import React, { useMemo } from 'react';
import { Box } from '@chakra-ui/react';
import PropTypes from 'prop-types';

import { useRecordQuestionRequirements } from '../../../../../../../../../../../services/record-service';
import QuestionRequirementIconButton from '../../../../QuestionRequirementIconButton';

const AiScanIcon = ({ recordId, policy }) => {
  const { data: questions, isLoading: questionsLoading } = useRecordQuestionRequirements(recordId);

  const relatedQuestions = useMemo(() => {
    if (questionsLoading) {
      return [];
    }

    return questions.filter(question => question.links.find(link => link.resourceType === 'insurance_policy_type' && link.resourceId === policy.insurancePolicyTypeId));
  }, [questions, questionsLoading]);

  return (
    <Box>
      {!questionsLoading && relatedQuestions?.length > 0 && (
        <QuestionRequirementIconButton
          policyId={policy.id}
          recordId={recordId}
          resourceDisplayName={policy.insurancePolicyType.displayName}
          resourceId={policy.insurancePolicyTypeId}
          resourceType="insurance_policy_type"
        />
      )}
    </Box>
  );
};

AiScanIcon.propTypes = {
  recordId: PropTypes.number.isRequired,
  policy: PropTypes.shape({
    id: PropTypes.number,
    insurancePolicyTypeId: PropTypes.number,
    insurancePolicyType: PropTypes.shape({ displayName: PropTypes.string })
  }).isRequired
};

export default AiScanIcon;
